import React from "react";
import TextModifierGenerator from "./TextModifierGenerator";
import { Button, Col, Row, Space, Tag } from "antd";
import { useState } from "react";
import { UpOutlined, UndoOutlined } from "@ant-design/icons";
import TextArea from "antd/lib/input/TextArea";
import CustomTagWithPlus from "../Tag/CustomTagWithPlus";
import EmailGenerator from "components/MailComponents/MailDetail/sendEmail/EmailGenerator";

interface TextGeneratorProps {
  text: any;
  onChange: (text: any) => void;
  newInstruction: string[];
  children?: any;
  onComplete: () => void;
  setNewInstruction?: any;
  isRefresh?: boolean;
  isTagPadding?: boolean;
}

const TextGenerator: React.FC<TextGeneratorProps> = ({
  text,
  onChange,
  onComplete,
  newInstruction,
  children,
  setNewInstruction,
  isRefresh = true,
  isTagPadding = true
}) => {
  const [otherInfo, setOtherInfo] = useState<boolean>(false);
  const [inputInstruction, setInputInstructions] = useState<string>("");
  const [error, setError] = useState<boolean>(false);
  const [instructions, setInstructions] = useState<string[]>([]);
  const [subject, setSubject] = useState<string>("");
  const [emailBody, setEmailBody] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);

  const handleEmailUpdate = (text: string) => {
    setEmailBody(text);
  };

  const handleSubjectUpdate = (subjectText: string) => {
    setSubject(subjectText);
  };

  const handleLoading = (isLoading: boolean) => {
    setLoading(isLoading);
  };

  const handleComplete = (profileId: any, subject: string, email: string) => {
    console.log("Email generation complete:", { profileId, subject, email });
  };

  const tags = [
    {
      label: "More Precise",
      icon: (
        <svg
          width="12"
          height="12"
          viewBox="0 0 12 12"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_40000073_48518)">
            <path
              d="M7 11C7 11 7.42462 10.9393 9.18198 9.18198C10.9393 7.42462 10.9393 4.57538 9.18198 2.81802C8.55934 2.19538 7.79964 1.79335 7 1.61191M7 11H10M7 11L7 8M5 1.0001C5 1.0001 4.57538 1.06076 2.81802 2.81812C1.06066 4.57548 1.06066 7.42472 2.81802 9.18208C3.44066 9.80472 4.20036 10.2068 5 10.3882M5 1.0001L2 1M5 1.0001L5 4"
              stroke="#0BA5EC"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <defs>
            <clipPath id="clip0_40000073_48518">
              <rect width="12" height="12" fill="white" />
            </clipPath>
          </defs>
        </svg>
      ),
    },
    // {
    //   label: "More Polite",
    //   icon: (
    //     <svg
    //       width="12"
    //       height="12"
    //       viewBox="0 0 12 12"
    //       fill="none"
    //       xmlns="http://www.w3.org/2000/svg"
    //     >
    //       <g clipPath="url(#clip0_40000073_48518)">
    //         <path
    //           d="M7 11C7 11 7.42462 10.9393 9.18198 9.18198C10.9393 7.42462 10.9393 4.57538 9.18198 2.81802C8.55934 2.19538 7.79964 1.79335 7 1.61191M7 11H10M7 11L7 8M5 1.0001C5 1.0001 4.57538 1.06076 2.81802 2.81812C1.06066 4.57548 1.06066 7.42472 2.81802 9.18208C3.44066 9.80472 4.20036 10.2068 5 10.3882M5 1.0001L2 1M5 1.0001L5 4"
    //           stroke="#0BA5EC"
    //           strokeWidth="1.5"
    //           strokeLinecap="round"
    //           strokeLinejoin="round"
    //         />
    //       </g>
    //       <defs>
    //         <clipPath id="clip0_40000073_48518">
    //           <rect width="12" height="12" fill="white" />
    //         </clipPath>
    //       </defs>
    //     </svg>
    //   ),
    // },
    {
      label: "Shorter",
      icon: (
        <svg
          width="12"
          height="12"
          viewBox="0 0 12 12"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_40000073_48518)">
            <path
              d="M7 11C7 11 7.42462 10.9393 9.18198 9.18198C10.9393 7.42462 10.9393 4.57538 9.18198 2.81802C8.55934 2.19538 7.79964 1.79335 7 1.61191M7 11H10M7 11L7 8M5 1.0001C5 1.0001 4.57538 1.06076 2.81802 2.81812C1.06066 4.57548 1.06066 7.42472 2.81802 9.18208C3.44066 9.80472 4.20036 10.2068 5 10.3882M5 1.0001L2 1M5 1.0001L5 4"
              stroke="#0BA5EC"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <defs>
            <clipPath id="clip0_40000073_48518">
              <rect width="12" height="12" fill="white" />
            </clipPath>
          </defs>
        </svg>
      ),
    },
    {
      label: "Longer",
      icon: (
        <svg
          width="12"
          height="12"
          viewBox="0 0 12 12"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_40000073_48518)">
            <path
              d="M7 11C7 11 7.42462 10.9393 9.18198 9.18198C10.9393 7.42462 10.9393 4.57538 9.18198 2.81802C8.55934 2.19538 7.79964 1.79335 7 1.61191M7 11H10M7 11L7 8M5 1.0001C5 1.0001 4.57538 1.06076 2.81802 2.81812C1.06066 4.57548 1.06066 7.42472 2.81802 9.18208C3.44066 9.80472 4.20036 10.2068 5 10.3882M5 1.0001L2 1M5 1.0001L5 4"
              stroke="#0BA5EC"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <defs>
            <clipPath id="clip0_40000073_48518">
              <rect width="12" height="12" fill="white" />
            </clipPath>
          </defs>
        </svg>
      ),
    },
  ];

  return (
    <>
      <Row>
        <Col span={isRefresh ? 20 : 24}>
          <Space className={`${isTagPadding ? "py-2" : ""} overflow-x-auto flex-wrap`}>
            {isRefresh && <Button
              icon={<UndoOutlined />}
              type="primary"
              onClick={() => {
                setInstructions(["refresh"]);
                setNewInstruction?.(["refresh"]);
              }}
              ghost
            >
              Refresh
            </Button>}

            {/* <Button type="primary" className="font-semibold">
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clipPath="url(#clip0_40000073_50007)">
                  <path
                    d="M3.75033 18.3327V14.166M3.75033 5.83268V1.66602M1.66699 3.74935H5.83366M1.66699 16.2493H5.83366M10.8337 2.49935L9.38851 6.25673C9.1535 6.86776 9.036 7.17327 8.85327 7.43025C8.69132 7.65801 8.49232 7.85701 8.26456 8.01896C8.00758 8.20169 7.70207 8.31919 7.09104 8.5542L3.33366 9.99935L7.09104 11.4445C7.70207 11.6795 8.00758 11.797 8.26456 11.9797C8.49232 12.1417 8.69132 12.3407 8.85327 12.5684C9.036 12.8254 9.1535 13.1309 9.38851 13.742L10.8337 17.4993L12.2788 13.742C12.5138 13.1309 12.6313 12.8254 12.8141 12.5684C12.976 12.3407 13.175 12.1417 13.4028 11.9797C13.6597 11.797 13.9652 11.6795 14.5763 11.4445L18.3337 9.99935L14.5763 8.5542C13.9652 8.31919 13.6597 8.20169 13.4028 8.01896C13.175 7.85701 12.976 7.65801 12.8141 7.43025C12.6313 7.17327 12.5138 6.86776 12.2788 6.25673L10.8337 2.49935Z"
                    stroke="white"
                    strokeWidth="1.66667"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_40000073_50007">
                    <rect width="20" height="20" fill="white" />
                  </clipPath>
                </defs>
              </svg>
              AI Generate
            </Button> */}

            {tags.map((tag) => (
              <CustomTagWithPlus
                key={tag.label}
                otherIcon={tag.icon}
                value={tag.label}
                isSelected={instructions.includes(tag.label)}
                handleClick={() => {
                  if (!instructions.includes(tag.label)) {
                    setInstructions([...instructions, tag.label]);
                    setNewInstruction?.([...instructions, tag.label]);
                  }
                }}
              />
            ))}

            {/* <CustomTagWithPlus
              otherIcon={<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clipPath="url(#clip0_40000073_48518)">
                  <path d="M7 11C7 11 7.42462 10.9393 9.18198 9.18198C10.9393 7.42462 10.9393 4.57538 9.18198 2.81802C8.55934 2.19538 7.79964 1.79335 7 1.61191M7 11H10M7 11L7 8M5 1.0001C5 1.0001 4.57538 1.06076 2.81802 2.81812C1.06066 4.57548 1.06066 7.42472 2.81802 9.18208C3.44066 9.80472 4.20036 10.2068 5 10.3882M5 1.0001L2 1M5 1.0001L5 4" stroke="#0BA5EC" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                </g>
                <defs>
                  <clipPath id="clip0_40000073_48518">
                    <rect width="12" height="12" fill="white" />
                  </clipPath>
                </defs>
              </svg>
              }
              value="More Precise"
              isSelected={false}
              handleClick={() => {
                if (!instructions.includes("Shorter")) {
                  setInstructions(["Shorter"]);
                }
              }}
            /> */}
            {/* <CustomTagWithPlus
              otherIcon={<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clipPath="url(#clip0_40000073_48518)">
                  <path d="M7 11C7 11 7.42462 10.9393 9.18198 9.18198C10.9393 7.42462 10.9393 4.57538 9.18198 2.81802C8.55934 2.19538 7.79964 1.79335 7 1.61191M7 11H10M7 11L7 8M5 1.0001C5 1.0001 4.57538 1.06076 2.81802 2.81812C1.06066 4.57548 1.06066 7.42472 2.81802 9.18208C3.44066 9.80472 4.20036 10.2068 5 10.3882M5 1.0001L2 1M5 1.0001L5 4" stroke="#0BA5EC" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                </g>
                <defs>
                  <clipPath id="clip0_40000073_48518">
                    <rect width="12" height="12" fill="white" />
                  </clipPath>
                </defs>
              </svg>
              }
              value={`Other ${!otherInfo ? <DownOutlined /> : <UpOutlined />}`}
              isSelected={false}
              handleClick={() => {
                setInstructions([]);
                setOtherInfo(!otherInfo);
              }}
            /> */}
          </Space>
        </Col>
      </Row>
      {(instructions && instructions.length) || newInstruction.length ? (
        <TextModifierGenerator
          instructions={instructions.length ? instructions : newInstruction}
          text={text}
          onComplete={() => {
            setInputInstructions("");
            setInstructions([]);
            setNewInstruction?.([]);
            onComplete();
          }}
          onChange={(text) => {
            onChange(text);
          }}
        />
      ) : (
        ""
      )}

      {children}

      {otherInfo ? (
        <>
          <Row>
            <Col span={20} offset={4} style={{ marginBottom: "10px" }}>
              <TextArea
                placeholder="eg: Ask for the meeting at the end"
                onChange={(e: any) => {
                  setInputInstructions(e.target.value);
                }}
              ></TextArea>
              {error ? (
                <div style={{ display: "flex", flexWrap: "nowrap" }}>
                  <div className="ant-form-item-explain ant-form-item-explain-connected">
                    <div role="alert" className="ant-form-item-explain-error">
                      Please input instructions
                    </div>
                  </div>
                </div>
              ) : (
                ""
              )}
            </Col>
          </Row>
          <Row justify="end" style={{ marginBottom: "10px" }}>
            <Col span={20} offset={4} style={{ textAlign: "right" }}>
              <Button
                className="m-5"
                onClick={() => {
                  setInputInstructions("");
                  setOtherInfo(!otherInfo);
                  setError(false);
                }}
              >
                Cancel
              </Button>
              <Button
                type="primary"
                className="m-5"
                onClick={() => {
                  if (inputInstruction) {
                    setInstructions([inputInstruction]);
                    setNewInstruction?.([inputInstruction]);
                    setInputInstructions("");
                    setOtherInfo(!otherInfo);
                  } else setError(true);
                }}
              >
                Done
              </Button>
            </Col>
          </Row>
          <EmailGenerator
            onEmailUpdate={handleEmailUpdate}
            onSubjectUpdate={handleSubjectUpdate}
            profileData={""}
            roleData={""}
            onComplete={handleComplete}
            onLoading={handleLoading}
            templateData={""}
            externalCompany={""}
          />
        </>
      ) : (
        ""
      )}
    </>
  );
};

export default TextGenerator;
